import React from 'react';
import PropTypes from 'prop-types';
import { getBgColor } from '$utilities/data';
import Image from '$partials/media/image';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @typedef {PropTypes.InferProps<typeof propTypes>} Props
 */
const ModulePopular = ({
    articles,
    section
}) => {

    if (!articles.items.length) { return null; }

    return (
        <div
            className={`${section.backgroundColor ? 'px-20 md:px-50 -mx-10 sm:mx-0 lg:-mx-30 py-40 md:py-50' : '' }`}
            style={{backgroundColor: getBgColor(section.backgroundColor)}}>
            <div className={`${section.backgroundColor ? '' : 'px-10 sm:px-20'} pb-30 md:pb-40`}>
                <h2 className='type-style-2 inline'>{section.title || 'Popular'}</h2>
            </div>
            <div className='w-full flex flex-wrap'>
                {articles.items.map((item, idx) => (
                    <a
                        className={`w-full sm:w-1/2 flex flex-wrap ${section.backgroundColor ? '' : 'px-10 sm:px-20'} ${idx > 1 ? 'pt-30 md:pt-60' : idx > 0 ? 'pt-30 sm:pt-0' : ''} ${(idx + 1) % 2 === 0 ? 'sm:pl-20' : 'sm:pr-20'}`}
                        href={`/articles/${item.slug}`}
                        key={`popular-${idx}`}>
                        <div className='hidden md:block w-1/6 pb-20 md:pb-60 border-b border-dark-grey type-style-3 md:type-style-1'>
                            {idx + 1}
                        </div>
                        <div className='w-full md:w-5/6 pb-20 md:pb-60 border-b border-dark-grey flex flex-wrap'>
                            {item.activities.items.length > 0 && (
                                <div className='flex items-center mb-20 ml-w-2/12 md:ml-0 pl-5 sm:pl-0 w-full'>
                                    {item.activities.items[0]?.icon && (
                                        <div className='mr-5'>
                                            <img
                                                className='pointer-events-none'
                                                height='23'
                                                loading='lazy'
                                                role='presentation'
                                                src={item.activities.items[0].icon.src}
                                                width='23' />
                                        </div>
                                    )}

                                    <p className='text-orange type-style-7 '>{item.activities.items[0]?.title}</p>
                                </div>
                            )}
                            <p className='w-2/12 md:hidden'>{idx + 1}</p>
                            <p className='pl-5 sm:pl-0 w-8/12 type-style-3 md:type-style-5'>{item.title}</p>
                        </div>
                    </a>
                ))}
            </div>
        </div>
    );
};

/* =========================================================================  */
/* Typing and export(s) */
/* =========================================================================  */

ModulePopular.propTypes = {
    articles: PropTypes.shape({
        items: PropTypes.array,
    }),
    section: PropTypes.object,
};

export default ModulePopular;
